interface UserRoleFederationComponentProps {
  primaryColor?: string;
  secondaryColor?: string;
  onClick?: (value: any) => void;
  style?: React.CSSProperties;

}

const UserRoleFederationSVGComponent = ({ primaryColor, secondaryColor, onClick, style }: UserRoleFederationComponentProps) => (
  <svg width={style?.width || 22} height={style?.height || 21} viewBox="0 0 22 21" fill="none" style={style ? style : undefined} onClick={onClick} xmlns="http://www.w3.org/2000/svg">

    <g id="Group">
      <path id="Vector" d="M15.4999 1.23999H7.12988V9.01001H15.4999V1.23999Z" stroke={primaryColor ? primaryColor : '#FF5349'} stroke-width="1.2699" stroke-miterlimit="10" />
      <path id="Vector_2" d="M21.3202 11.99H12.9502V19.76H21.3202V11.99Z" stroke={primaryColor ? primaryColor : '#FF5349'} stroke-width="1.2699" stroke-miterlimit="10" />
      <path id="Vector_3" d="M9.37 11.99H1V19.76H9.37V11.99Z" stroke={primaryColor ? primaryColor : '#FF5349'} stroke-width="1.2699" stroke-miterlimit="10" />
    </g>
  </svg>

);

export default UserRoleFederationSVGComponent;
